import React, { useEffect, useRef, useState } from 'react';

import ProfileTopbar from './ProfileTopbar';

import { useTranslation } from 'react-i18next';
import { CarouselItemTemplate, CustomAddImage, CustomEditProfile, CustomFollowLayer, CustomGaleria, CustomInvite, CustomFeaturedSelectExhibit, CustomAddPanel, CustomAddArtworks } from '../../components';
import AuthService from '../../security/AuthService';
import { Button } from 'primereact/button';
import { Link, useNavigate, useParams } from 'react-router-dom';
import ProfileService from '../../service/ProfileService';
import EventBus from "../../common/EventBus";
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import FileService from '../../service/FileService';
import { FileUpload } from 'primereact/fileupload';
import Constants from '../../constants/Constants';
import ExhibitionService from '../../service/ExhibitionService';
import ExhibitionCarousel2 from '../../components/ExhibitionCarousel2';
import FavoriteService from '../../service/FavoriteService';
import { set } from 'date-fns';


export const Profile = (props) => {
    const { t } = useTranslation();
    const toast = useRef(null);
    const navigate = useNavigate();

    const [displayLoadingDialog, setDisplayLoadingDialog] = useState(false);

    const [itemWidth, setItemWidth] = useState(250);
    const itemHeight = 410;
    const [readMore, setReadMore] = React.useState(false);
    let { profileId, userType } = useParams();

    const [isEdit, setIsEdit] = useState(false);

    const [profileInfo, setProfileInfo] = useState();

    const [followerVisible, setFollowerVisible] = useState(false);
    const [followedVisible, setFollowedVisible] = useState(false);

    const [follower, setFollower] = useState([]);
    const [followed, setFollowed] = useState([]);


    const [artworks, setArtworks] = useState([]);
    const [exhibits, setExhibits] = useState([]);


    const [addImageVisible, setAddImageVisible] = useState(false);
    const [featuredExhibitVisible, setFeaturedExhibitVisible] = useState(false);
    const [selectedFeaturedExhibit, setSelectedFeaturedExhibit] = useState();

    const [imageFileType, setImageFileType] = useState();

    const [profileImage, setProfileImage] = useState('/assets/layout/images/profile-image.png');
    const [profileImageData, setProfileImageData] = useState();
    const [removeProfileImageData, setRemoveProfileImageData] = useState();


    const [headerImage, setHeaderImage] = useState();
    const [headerImageData, setHeaderImageData] = useState();

    const [inviteVisible, setInviteVisible] = useState(false);


    let fileUploadRef1 = useRef();
    let fileUploadRef2 = useRef();

    const defaultFeaturedExhibit = {
        headerimageData: {
            file: '/assets/layout/images/error_image.png'
        },
        exhibitionName: "",
        firstName: "",
        lastName: "",
        profileImage: '/assets/layout/images/default_profile.png'
    };

    const [featuredExhibitFirst, setFeaturedExhibitFirst] = useState(defaultFeaturedExhibit);
    const [featuredExhibitSecond, setFeaturedExhibitSecond] = useState(defaultFeaturedExhibit);



    const toggleReadMore = () => {
        setReadMore(!readMore);
    };

    useEffect(() => {
        loadUserProfile();
        loadUserArtworks();
        loadUserExhibits(Constants.exhibitionStatus.PUBLISHED);
    }, []);

    const loadUserProfile = async () => {
        setDisplayLoadingDialog(true);
        setProfileInfo([]);
        ProfileService.inquireProfileInfo(profileId).then(
            (response) => {

                console.log("loadUserProfile", response)
                if (response?.data?.data?.dataList?.length > 0) {
                    console.log("set setProfileInfo", response?.data?.data?.dataList[0])
                    setProfileInfo(response?.data?.data?.dataList[0]);
                    prapareProfileImage(response?.data?.data?.dataList[0]);
                    prapareFeaturedExhibits(response?.data?.data?.dataList[0]);
                }
                setDisplayLoadingDialog(false);
            },
            (error) => {
                console.log("inquireCharVal error*", error)

                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("inquireCharVal logout******")
                    EventBus.dispatch("logout", props);
                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );


    }
    const prapareFeaturedExhibits = (param) => {
        if (param.details?.featuredExhibitFirst?.length > 0) {
            loadFeaturedExhibit(param.details.featuredExhibitFirst[0].val, setFeaturedExhibitFirst);

        }
        if (param.details?.featuredExhibitSecond?.length > 0) {
            loadFeaturedExhibit(param.details.featuredExhibitSecond[0].val, setFeaturedExhibitSecond);
        }


    }

    const loadFeaturedExhibit = (id, onAction) => {
        setDisplayLoadingDialog(true);
      //  setArtworks([]);
        ExhibitionService.inquireExhibit(id).then(
            (response) => {

                console.log("loadFeaturedExhibit", response)
                if (response?.data?.data?.dataList?.length > 0) {
                    console.log("set loadUserArtworks", response?.data?.data?.dataList)
                    onAction(response?.data?.data?.dataList[0]);
                }
                setDisplayLoadingDialog(false);
            },
            (error) => {
                console.log("loadFeaturedExhibit error*", error)

                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("loadFeaturedExhibit logout******")
                    EventBus.dispatch("logout", props);
                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );
    }


    const loadUserArtworks = async () => {
        setDisplayLoadingDialog(true);
        setArtworks([]);
        ProfileService.inquireArtworks(profileId).then(
            (response) => {

                console.log("loadUserArtworks", response)
                if (response?.data?.data?.dataList?.length > 0) {
                    console.log("set loadUserArtworks", response?.data?.data?.dataList)
                    setArtworks(response?.data?.data?.dataList);
                }
                setDisplayLoadingDialog(false);
            },
            (error) => {
                console.log("loadUserArtworks error*", error)

                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("loadUserArtworks logout******")
                    EventBus.dispatch("logout", props);
                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );
    }

    const loadUserExhibits = async (param) => {
        setDisplayLoadingDialog(true);
        setExhibits([]);
        ExhibitionService.inquireExhibitByUserAndStatus(profileId, param).then(
            (response) => {
                console.log("inquireExhibitByStatus", response)
                console.log("inquireExhibitByStatus", response?.data?.data?.dataList)
                if (response?.data?.data?.dataList?.length > 0) {
                    console.log("set inquireExhibitByStatus", response?.data?.data?.dataList)
                    setExhibits(response?.data?.data?.dataList);
                }
                setDisplayLoadingDialog(false);
            },
            (error) => {
                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("inquireExhibitByStatus logout******")
                    EventBus.dispatch("logout", props);
                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );

    }


    const onEditClear = () => {
        setIsEdit(false);
        setHeaderImageData();
        setProfileImageData();
        setRemoveProfileImageData();
    }

    const onRemoveHeaderImage = (profileInfo) => {
        console.log("onRemoveHeaderImage:", profileInfo);

        let _headerImage = { key: "images", code: "profile_header" };
        setHeaderImage();
        setRemoveProfileImageData(_headerImage);


    }


    const onSave = (profileInfo) => {

        console.log(profileInfo)





        console.log("onSave");
        setDisplayLoadingDialog(true);

        let apiParams = profileInfo;

        if (featuredExhibitFirst.id) {
            let _featuredExhibitFirst = { id: '-10', val: featuredExhibitFirst.id, key: "featuredExhibitFirst" };
            if (apiParams.details?.featuredExhibitFirst?.length > 0) {
                apiParams.details.featuredExhibitFirst[0].val = featuredExhibitFirst.id;
            } else {
                apiParams.details.featuredExhibitFirst = [];
                apiParams.details.featuredExhibitFirst.push(_featuredExhibitFirst);
            }
        } else {
            if (apiParams.details?.featuredExhibitFirst?.length > 0) {
                apiParams.details.featuredExhibitFirst = [];
            }
        }

        if (featuredExhibitSecond.id) {
            let _featuredExhibitSecond = { id: '-11', val: featuredExhibitSecond.id, key: "featuredExhibitSecond" };
            if (apiParams.details?.featuredExhibitSecond?.length > 0) {
                profileInfo.details.featuredExhibitSecond[0].val = featuredExhibitSecond.id;
            } else {
                apiParams.details.featuredExhibitSecond = [];
                apiParams.details.featuredExhibitSecond.push(_featuredExhibitSecond);
            }
        } else {
            if (apiParams.details?.featuredExhibitSecond?.length > 0) {
                apiParams.details.featuredExhibitSecond = [];
            }
        }


        let _fileUpload = [];
        if (profileImageData) {
            _fileUpload.push(profileImageData);
        }
        if (headerImageData) {
            _fileUpload.push(headerImageData);
        }

        let _removeFile = [];
        if (removeProfileImageData) {
            _removeFile.push(removeProfileImageData);
        }

        apiParams = { ...apiParams, fileUploads: _fileUpload, removeFile: _removeFile }

        console.log("onSave", apiParams);

        ProfileService.save(apiParams).then(
            (response) => {

                console.log("onRegister", response);

                if (response?.data?.error) {
                    setDisplayLoadingDialog(false);

                    let _detail = response.data.error?.innerExceptionMessage;
                    if (t(_detail)) {
                        _detail = t(_detail);
                    }


                    toast.current.show({ severity: 'error', summary: t('global_text_errorsummary'), detail: _detail, life: 10000 });
                } else {
                    console.log("onSave", response);

                    setDisplayLoadingDialog(false);
                    loadUserProfile();
                    setIsEdit(false);

                    if (profileImageData) {
                        console.log("profileImageData ", profileImageData);
                        let _filepath = profileImageData.file.replaceAll("\\", "\/");
                        if (_filepath.indexOf("/assets/layout/images") >= 0) {
                            AuthService.setProfileImage(profileImageData.file);
                        } else {
                            let fileExt = profileImageData.fileName.split('.').pop();

                            AuthService.setProfileImage("stored_files/profile_photo/" + AuthService.getUserId() + "." + fileExt);
                        }

                    }
                    if (headerImageData) {
                        console.log("headerImageData ", headerImageData);

                        let _filepath = headerImageData.file.replaceAll("\\", "\/");
                        if (_filepath.indexOf("/assets/layout/images") >= 0) {
                            AuthService.setHeaderImage(headerImageData.file);
                        } else {
                            let fileExt = headerImageData.fileName.split('.').pop();
                            AuthService.setHeaderImage("stored_files/profile_header/" + AuthService.getUserId() + "." + fileExt);
                        }
                    }

                    let _detail = t('global_success')

                    toast.current.show({ severity: 'success', summary: t('global_text_successsummary'), detail: _detail, life: 3000 });
                }
            },
            (error) => {
                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                    EventBus.dispatch("logout", props);

                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );



    }


    const followUser = (param) => {

        console.log("unFollowUser");


        if (!AuthService.isLoggedIn()) {
            toast.current.show({ severity: 'info', summary: t('global_text_info'), detail: t('global_error_authendication'), life: 3000 });
        } else {

            console.log(param)


            console.log("followUser");
            setDisplayLoadingDialog(true);


            console.log("addFollow", param);

            ProfileService.addFollow(param).then(
                (response) => {

                    console.log("addFollow", response);

                    if (response?.data?.error) {
                        setDisplayLoadingDialog(false);

                        let _detail = response.data.error?.innerExceptionMessage;
                        if (t(_detail)) {
                            _detail = t(_detail);
                        }


                        toast.current.show({ severity: 'error', summary: t('global_text_errorsummary'), detail: _detail, life: 10000 });
                    } else {
                        setDisplayLoadingDialog(false);

                        console.log("addFollow", response);

                        let _detail = t('global_success')
                        profileInfo.isFollowed = 1;
                        toast.current.show({ severity: 'success', summary: t('global_text_successsummary'), detail: _detail, life: 3000 });
                        loadFollower();

                    }
                },
                (error) => {
                    setDisplayLoadingDialog(false);

                    const _content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    console.log(_content);

                    if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                        EventBus.dispatch("logout", props);

                    } else {
                        toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                    }
                }
            );
        }


    }

    const unFollowUser = (param) => {

        console.log(param)


        console.log("unFollowUser");
        setDisplayLoadingDialog(true);


        console.log("removeFollow", param);

        ProfileService.removeFollow(param).then(
            (response) => {

                console.log("removeFollow", response);

                if (response?.data?.error) {
                    setDisplayLoadingDialog(false);

                    let _detail = response.data.error?.innerExceptionMessage;
                    if (t(_detail)) {
                        _detail = t(_detail);
                    }


                    toast.current.show({ severity: 'error', summary: t('global_text_errorsummary'), detail: _detail, life: 10000 });
                } else {
                    setDisplayLoadingDialog(false);

                    console.log("addFollow", response);

                    let _detail = t('global_success')
                    profileInfo.isFollowed = 0;
                    loadFollower();

                    toast.current.show({ severity: 'success', summary: t('global_text_successsummary'), detail: _detail, life: 3000 });
                }
            },
            (error) => {
                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                    EventBus.dispatch("logout", props);

                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );



    }

    const renderContacts = () => {

        if (profileInfo?.details?.contacts?.length > 0) {
            let _contacts = profileInfo?.details?.contacts;
            return (
                _contacts?.map((param, index) => {
                    let _ico =
                        param?.code === "behance.net" ? "fa-brands fa-behance" :
                            param?.code === "facebook.com" ? "fa-brands fa-facebook" :
                                param?.code === "instagram.com" ? "fa-brands fa-instagram" :
                                    param?.code === "youtube.com" ? "fa-brands fa-youtube" :
                                        param?.code === "deviantart.com" ? "fa-brands fa-deviantart" :
                                            param?.code === "linkedin.com" ? "fa-brands fa-linkedin" :
                                                param?.code === "twitter.com" ? "fa-brands fa-twitter" :
                                                    param?.code === "x.com" ? "fa-brands fa-x-twitter" :
                                                        param?.code === "flickr.com" ? "fa-brands fa-flickr" :
                                                            param?.code === "soundcloud.com" ? "fa-brands fa-soundcloud" :
                                                                param?.code === "vimeo.com" ? "fa-brands fa-vimeo-v" :
                                                                    param?.code === "spotify.com" ? "fa-brands fa-spotify" :
                                                                        param?.code === "pinterest.com" ? "fa-brands fa-pinterest" :
                                                                            param?.code === "tiktok.com" ? "fa-brands fa-tiktok" :
                                                                                param?.code === "snapchat.com" ? "fa-brands fa-snapchat" :
                                                                                    "fas fa-globe";



                    return (
                        <Link key={index} to={param?.val} target="_blank">
                            <Button icon={_ico} className={"p-button-rounded p-button-header mr-2 mb-2"} >
                            </Button>
                        </Link>
                    )
                })
            )

        }

    }




    const featuredExhibitHandler = (param) => {
        console.log("featuredExhibitHandler", param);
        setSelectedFeaturedExhibit(param);
        setFeaturedExhibitVisible(true);

    };

    const onAddFavorite = (entityName, artwork) => {

        console.log("onAddFavorite");
        setDisplayLoadingDialog(true);

        let userId = AuthService.getUserId();

        //let rowId = exhibitId;
        //if (Constants.entityNames.artwork === entityName) {
        let rowId = artwork?.id
        //}

        let apiParams = { userId, entityName, rowId }

        console.log("onAddFavorite", apiParams);

        FavoriteService.add(apiParams).then(
            (response) => {

                console.log("onAddFavorite", response);

                if (response?.data?.error) {
                    setDisplayLoadingDialog(false);

                    let _detail = response.data.error?.innerExceptionMessage;
                    if (t(_detail)) {
                        _detail = t(_detail);
                    }


                    toast.current.show({ severity: 'error', summary: t('global_text_errorsummary'), detail: _detail, life: 10000 });
                } else {
                    console.log("onSave", response?.data?.data?.id);
                    //if (Constants.entityNames.artwork === entityName) {
                    artwork.favoriteId = response?.data?.data?.id;
                    //} else {
                    //  setFavoriteId(response?.data?.data?.id);
                    //}

                    setDisplayLoadingDialog(false);

                    let _detail = t('global_success')

                    toast.current.show({ severity: 'success', summary: t('global_text_successsummary'), detail: _detail, life: 3000 });
                }
            },
            (error) => {
                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                    EventBus.dispatch("logout", props);

                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );


    }



    const onRemoveArtwork = (artwork) => {

        console.log("onRemoveArtwork");
        setDisplayLoadingDialog(true);



        let apiParams = { id: artwork?.id }

        console.log("onRemoveArtwork", apiParams);

        FileService.removeFile(apiParams).then(
            (response) => {

                console.log("onRemoveArtwork", response);

                if (response?.data?.error) {
                    setDisplayLoadingDialog(false);

                    let _detail = response.data.error?.innerExceptionMessage;
                    if (t(_detail)) {
                        _detail = t(_detail);
                    }


                    toast.current.show({ severity: 'error', summary: t('global_text_errorsummary'), detail: _detail, life: 10000 });
                } else {
                    console.log("onRemoveArtwork", response?.data?.data?.id);

                    loadUserArtworks();

                    setDisplayLoadingDialog(false);

                    let _detail = t('global_success')

                    toast.current.show({ severity: 'success', summary: t('global_text_successsummary'), detail: _detail, life: 3000 });
                }
            },
            (error) => {
                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                    EventBus.dispatch("logout", props);

                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );


    }


    const onRemoveFavorite = (favoriteId, artwork) => {

        console.log("onRemoveFavorite");
        setDisplayLoadingDialog(true);



        let apiParams = { id: favoriteId }

        console.log("onRemoveFavorite", apiParams);

        FavoriteService.remove(apiParams).then(
            (response) => {

                console.log("onRemoveFavorite", response);

                if (response?.data?.error) {
                    setDisplayLoadingDialog(false);

                    let _detail = response.data.error?.innerExceptionMessage;
                    if (t(_detail)) {
                        _detail = t(_detail);
                    }


                    toast.current.show({ severity: 'error', summary: t('global_text_errorsummary'), detail: _detail, life: 10000 });
                } else {
                    artwork.favoriteId = null;

                    console.log("onSave", response);

                    setDisplayLoadingDialog(false);

                    let _detail = t('global_success')

                    toast.current.show({ severity: 'success', summary: t('global_text_successsummary'), detail: _detail, life: 3000 });
                }
            },
            (error) => {
                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                    EventBus.dispatch("logout", props);

                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );


    }


    const renderArtWorks1 = () => {
        return (
            <div className="grid icons-list text-center">

                {artworks.map((param, index) => {
                    return (
                        <div className="col-6 sm:col-4 lg:col-3 xl:col-2 pb-5" key={index} style={{ width: 275, height: 286 }}>
                            <img id="imageid"
                                src={param.file}
                                alt="artwork"
                                style={{ width: 275, height: 286 }}
                            />


                        </div>
                    )
                })
                }
            </div>
        )

    }

    const renderArtWorks = () => {
        console.log("renderArtWorks", artworks?.length, artworks)
        return (
            <div className='pt-5  p-3'>
                {artworks?.length > 0 &&
                    <div>
                        <div className='text-5xl  font-600-regular pt-3 pb-5'>
                            {t('artwork_header1_with_user', { username: profileInfo.userType==Constants.userType.company ? profileInfo?.companyName : profileInfo?.fullName })}
                        </div>
                        <CustomGaleria artworks={artworks} onAddFavorite={onAddFavorite} onRemoveFavorite={onRemoveFavorite} onRemoveArtwork={onRemoveArtwork} ></CustomGaleria>
                    </div>
                }
                {artworks?.length === 0 &&
                    <div>
                        <div className='text-2xl  font-500-regular pt-3 pb-5 text-center'>
                            {t('artwork_empty')}
                        </div>
                        <CustomGaleria artworks={artworks}></CustomGaleria>
                    </div>
                }
            </div>
        )

    }




    const renderExhibits = () => {
        return (
            <div className='pt-5  p-3'>
                {exhibits?.length > 0 &&
                    <div>
                        <div className='flex flex-row justify-content-between responsive-grid '>
                            <div className='text-5xl  font-600-regular pt-3 pb-5'>
                                {t('exhibit_header1_with_user', { username: profileInfo.userType==Constants.userType.company ? profileInfo?.companyName : profileInfo?.fullName })}
                            </div>
                            <div>
                                <Button label={t('global_text_viewing_allexhibitions')} className={"p-button-rounded p-button-header mr-2 mb-2"}
                                    onClick={(e) => {

                                        //  {"/exhibit/" + AuthService.getUserId() } 
                                        console.log("sfdsfa")
                                        navigate("/exhibit/" + profileId);

                                    }}
                                />
                            </div>
                        </div>
                        <ExhibitionCarousel2 data={exhibits} navigate={navigate}></ExhibitionCarousel2>
                    </div>
                }
                {exhibits?.length === 0 &&
                    <div>
                        <div className='text-2xl  font-500-regular pt-3 pb-5 text-center'>
                            {t('exhibts_empty')}
                        </div>
                    </div>
                }
            </div>
        )

    }

    const loadFollower = async () => {
        setFollower([]);
        setDisplayLoadingDialog(true);
        ProfileService.inquireFollower(profileInfo?.id).then(
            (response) => {

                console.log("inquireFollower", response)
                if (response?.data?.data?.dataList?.length > 0) {
                    console.log("set inquireFollower", response?.data?.data?.dataList)
                    setFollower(response?.data?.data?.dataList);
                  
                }
                let _profileInfo = profileInfo;

                _profileInfo.followerCount = response?.data?.data?.dataList?.length;
                setProfileInfo(_profileInfo);
                setDisplayLoadingDialog(false);
               

            },
            (error) => {
                console.log("inquireFollower error*", error)

                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("inquireFollower logout******")
                    EventBus.dispatch("logout", props);
                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );
    }
    const loadFollowed = async () => {
        setDisplayLoadingDialog(true);
        setFollowed([]);
        console.log("loadFollowed")
        ProfileService.inquireFollowed(profileInfo?.id).then(
            (response) => {
                console.log("inquireFollowed", response)
                if (response?.data?.data?.dataList?.length > 0) {
                    console.log("set inquireFollowed", response?.data?.data?.dataList)
                    setFollowed(response?.data?.data?.dataList);
                }
                setDisplayLoadingDialog(false);
               // setFollowedVisible(true);

            },
            (error) => {
                console.log("inquireFollowed error*", error)

                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("inquireFollowed logout******")
                    EventBus.dispatch("logout", props);
                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );
    }

    const loadFollow = (param) => {

        if (param === "follower") {
            loadFollower();
            setFollowerVisible(true);
        } else {
            loadFollowed();
            setFollowedVisible(true);
        }
       

    }

    const renderFollow = (param) => {
        return (
            <Dialog showCloseIcon closeOnEscape dismissable={false} visible={followedVisible || followerVisible} position={'top'}
                onHide={() => {
                    setFollowerVisible(false)
                    setFollowedVisible(false)
                }
                }
                className={'follow-dialog '} headerClassName='follow-dialog-header'
                contentClassName='follow-dialog-content' >

                <div className="grid follow-content align-items-center justify-content-between pl-3 pr-3">
                    <div className="pt-4 pb-3 pl-3   font-black  text-xl  font-500-regular" >

                        {followerVisible ? t("global_text_follower") : t("global_text_followed")}


                    </div>
                    {followerVisible && follower.map((param, index) => {
                        return (
                            <CustomFollowLayer key={index} param={param} followUser={followUser} unFollowUser={unFollowUser} ></CustomFollowLayer>

                        )
                    })}
                    {followedVisible && followed.map((param, index) => {
                        return (
                            <CustomFollowLayer key={index} param={param} followUser={followUser} unFollowUser={unFollowUser} ></CustomFollowLayer>

                        )
                    })}
                </div>


            </Dialog>

        )


    }

    const uploadImageLayer = () => {
        return (
            <Dialog showCloseIcon closeOnEscape dismissable={false} visible={addImageVisible} position={'top'} onHide={() => setAddImageVisible(false)} className={'search-dialog'} headerClassName='search-dialog-header' contentClassName='search-dialog-content' >

                <CustomAddImage toast={toast} setDialogVisible={setAddImageVisible} {...props}
                    imageKey={"images"} code={imageFileType}
                    setImage={onSetProfileImage}
                    loadDefaultImages={true}
                ></CustomAddImage>

            </Dialog>

        )


    }
    const selectFeaturedExhibitLayer = () => {
        return (
            <Dialog showCloseIcon closeOnEscape dismissable={false} visible={featuredExhibitVisible} position={'top'} onHide={() => setFeaturedExhibitVisible(false)} className={'search-dialog'} headerClassName='search-dialog-header' contentClassName='search-dialog-content' >

                <CustomFeaturedSelectExhibit toast={toast} setDialogVisible={setFeaturedExhibitVisible} {...props}
                    imageKey={"images"} code={imageFileType}
                    onSetFeaturedExhibit={onSetFeaturedExhibit}
                    loadDefaultImages={true}
                ></CustomFeaturedSelectExhibit>

            </Dialog>

        )


    }
    /*
    const loadFile = async (path, action) => {
        //setDisplayLoadingDialog(true);
        action([]);
        console.log("loadFile")
        FileService.inquireFile(path).then(
            (response) => {
                console.log("loadFile", response)
                if (response?.data) {
                    console.log("set loadFile", response?.data)
                    action(response?.data);
                }
                // setDisplayLoadingDialog(false);
                //setFollowedVisible(true);

            },
            (error) => {
                console.log("loadFile error*", error)

                //  setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("inquireFollowed logout******")
                    EventBus.dispatch("logout", props);
                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );
    }*/

    const onStoreProfileImage = async (param) => {
        setProfileImage(param);


    }
    const onStoreHeaderImage = async (param) => {
        setHeaderImage(param);
    }
    const prapareProfileImage = (_profileInfo) => {
        console.log("getProfileImage", _profileInfo?.details?.images)
        if (_profileInfo?.details?.images?.length > 0) {
            _profileInfo?.details?.images.map((param, index) => {
                console.log("getProfileImage map", param, " *** ", Constants.fileTypes.profile_photo)
                let _imagePath = param.val;
                console.log("_imagePath equal", _imagePath, _imagePath.indexOf("\\assets\\layout\\images"))
                if (_imagePath.indexOf("\\assets\\layout\\images") >= 0 || _imagePath.indexOf("/assets/layout/images") >= 0) {
                    _imagePath = _imagePath.replaceAll("\\", "\/");


                    if (param.code === Constants.fileTypes.profile_photo) {
                        console.log("getProfileImage equal", param.val)
                        onStoreProfileImage(_imagePath);

                    }
                    if (param.code === Constants.fileTypes.profile_header) {
                        console.log("profile_header equal", param.val, _imagePath)
                        onStoreHeaderImage(_imagePath);

                    }
                } else {
                    _imagePath = _imagePath.replaceAll("\\", "\/");

                    console.log("_imagePath equal 1", _imagePath)
                    if (param.code === Constants.fileTypes.profile_photo) {
                        if (_imagePath) {
                            console.log("getProfileImage equal", param.val)
                            // setProfileImage(_imagePath);
                            //loadFile(_imagePath, onStoreProfileImage)
                            onStoreProfileImage(FileService.inquireFilePath(_imagePath));
                        }

                    }
                    if (param.code === Constants.fileTypes.profile_header) {
                        if (_imagePath) {
                            console.log("profile_header equal", param.val, _imagePath)
                            //loadFile(_imagePath, onStoreHeaderImage)
                            onStoreHeaderImage(FileService.inquireFilePath(_imagePath));
                        }

                        //  setHeaderImage(_imagePath);
                    }
                }
            })

        }
        return null;

    }

    const onSetProfileImage = (param) => {
        if (Constants.fileTypes.profile_photo === param?.code) {
            //setProfileImage(param.file);
            setProfileImageData(param);
        } else if (Constants.fileTypes.profile_header === param?.code) {
            // setHeaderImage(param.file);
            setHeaderImageData(param);
        }

    }
    const onSetFeaturedExhibit = (param,) => {
        console.log("onSetFeaturedExhibit", param, selectedFeaturedExhibit)
        selectedFeaturedExhibit == Constants.featuredExhibition.first ? setFeaturedExhibitFirst(param) : setFeaturedExhibitSecond(param);
        setFeaturedExhibitVisible(false);

    }


    const inviteLayer = () => {
        return (
            <Dialog showCloseIcon closeOnEscape dismissable={false} visible={inviteVisible} position={'top'} onHide={() => setInviteVisible(false)} className={'search-dialog'} headerClassName='search-dialog-header' contentClassName='search-dialog-content' >

                <CustomInvite toast={toast} setDialogVisible={setInviteVisible} {...props}
                ></CustomInvite>

            </Dialog>

        )


    }

    return (
        <div className='surface-profile-header'
            style={{
                backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1)),  url(${headerImageData?.file ? headerImageData?.file : headerImage})`,
            }}
        >
            <Toast ref={toast} />
            <Dialog visible={displayLoadingDialog} breakpoints={{ '960px': '75vw' }} closable={false} className='p-dialog-load' header={<></>} >
                <div>
                    <img src="/assets/layout/images/page-loader.gif" alt='Loading...' width="125px" height="125px">
                    </img>
                </div>
            </Dialog>
            <div className='root-profile' style={{ paddingBottom: 70, }}>
                <div className="grid grid-nogutter surface-profile-main text-800">
                    <ProfileTopbar {...props} loadUserArtworks={loadUserArtworks} />




                    <div className="surface-profile" >


                        <div className="surface-profile-info col-12 p-0 md:text-left flex flex-row align-items-top justify-content-between" >
                            <div className="flex flex-row justify-content-start align-items-start " >
                                <div className="flex flex-column align-items-start " >
                                    <div className="surface-profile-details flex flex-row justify-content-between ">

                                        <div className="flex flex-row justify-content-between " >
                                            <div className="justify-content-start">
                                                <div className='flex flex-row align-items-end'>
                                                    <div className='flex flex-row align-items-end'>

                                                        <div style={{

                                                            color: '#ffffff',
                                                            textAlign: 'center',
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            flexDirection: 'column', // inner items will be added vertically
                                                            flexGrow: 1,            // all the available vertical space will be occupied by it
                                                            backgroundColor: "gray",
                                                            height: 100,
                                                            width: 100,
                                                            borderRadius: 50,
                                                            backgroundImage: `url(${profileImageData?.file ? profileImageData?.file : profileImage ? profileImage : "/assets/layout/images/profile-image.png"})`,
                                                            backgroundRepeat: "no-repeat",
                                                            backgroundSize: "cover",

                                                        }}>

                                                        </div>
                                                        {!isEdit && profileInfo?.hasBluetick === 1 &&
                                                            <div
                                                                className="blue-check-point-20 " style={{ marginLeft: "-35px", marginTop: "-35px" }} >
                                                                <i className="fas fa-check" style={{ fontSize: '15px' }} ></i>


                                                            </div>
                                                        }
                                                        {isEdit &&
                                                            <div
                                                                className="" style={{ marginLeft: "-35px", marginTop: "-35px" }} >
                                                                <Button icon="fas fa-cloud-arrow-up" className={"p-button-rounded p-button-header"}
                                                                    onClick={() => {
                                                                        setImageFileType(Constants.fileTypes.profile_photo);
                                                                        setAddImageVisible(true)
                                                                    }
                                                                    }
                                                                />

                                                            </div>
                                                        }

                                                    </div>
                                                    <div className='flex flex-column ml-4 '>
                                                        <div className="block text-5xl mb-1 font-white font-400-regular ">
                                                            {profileInfo?.userType==Constants.userType.company ? profileInfo?.companyName : profileInfo?.fullName}
                                                        </div>
                                                        <div className="text-xl font-gray font-400-regular ">
                                                            @{profileInfo?.userName} &#183; {profileInfo?.userType==Constants.userType.company ? t('company_type_' +profileInfo?.companyType) : t('global_text_' + profileInfo?.userType)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex justify-content-end align-items-end">
                                            <div className='flex flex-column mr-4 align-items-end'>
                                                <div className="block text-xl mb-2 font-gray font-400-regular ">
                                                    <Button label={t('global_text_follower_descr', { followerCount: profileInfo?.followerCount })} className='font-white' severity="secondary" text style={{ paddingRight: 0 }}
                                                        onClick={(e) => {
                                                            loadFollow("follower");
                                                        }}
                                                    />
                                                    <Button label={t('global_text_following_descr', { followingCount: profileInfo?.followedCount })} className='font-white' severity="secondary" text
                                                        onClick={(e) => {
                                                            loadFollow("followed");
                                                        }}
                                                    />
                                                    {renderFollow()}
                                                </div>
                                                <div className='flex flex-row'>
                                                    {profileId == AuthService.getUserId() &&
                                                        <Button icon="fas fa-envelope-open-text" label={t('global_text_invite')} className={"p-button-rounded p-button-header mr-2 mb-2 pr-3 pl-3"}
                                                            onClick={() => setInviteVisible(true)}
                                                        >

                                                        </Button>
                                                    }
                                                    {profileId != AuthService.getUserId() &&
                                                        profileInfo?.userType != 'artlover' &&
                                                        <Button label={profileInfo?.isFollowed === 0 ? t('global_text_follow') : t('global_text_unfollow')} className={"p-button-rounded p-button-header mr-2 mb-2 pr-3 pl-3"}
                                                            onClick={() => {
                                                                if (profileInfo?.isFollowed === 0) {
                                                                    followUser(profileId);
                                                                } else {
                                                                    unFollowUser(profileId);

                                                                }

                                                            }}
                                                        >

                                                        </Button>
                                                    }
                                                    {renderContacts()}
                                                    {profileId == AuthService.getUserId() &&
                                                        <Button icon="fas fa-user-pen"
                                                            className={isEdit ? "p-button-rounded mr-2 mb-2" : "p-button-rounded p-button-header mr-2 mb-2"}
                                                            onClick={() => setIsEdit(!isEdit)}
                                                        >
                                                        </Button>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="justify-content-end mt-8 ">
                                        {!isEdit &&
                                            <div className="flex flex-column justify-content-between w12" >


                                                <div className="container-read-more">
                                                    <div className={`card${readMore ? ' active' : ''}`}>
                                                        <div className="content">
                                                            <div className="block text-2xl mb-1 font-400-regular ">
                                                                {profileInfo?.details?.description?.length > 0 ? profileInfo?.details?.description[0]?.val : ""}
                                                            </div>
                                                        </div>



                                                    </div>
                                                </div>

                                                <div className="flex justify-content-center  align-items-center "
                                                    style={{ marginTop: readMore ? -40 : -55 }}
                                                >
                                                    <Button icon={readMore ? 'fa fas fa-chevron-up' : 'fa fas fa-chevron-down'}
                                                        className={"p-button-text"}
                                                        style={{ fontSize: '3rem', width: 34, height: 34 }}
                                                        onClick={toggleReadMore}

                                                    >
                                                    </Button>
                                                </div>

                                            </div>
                                        }
                                        {isEdit &&
                                            <CustomEditProfile profileInfo={{ ...profileInfo }} onSave={onSave} onEditClear={onEditClear} />
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="justify-content-start align-items-start">
                                <div className="flex flex-column justify-content-start align-items-start " >
                                    {
                                        isEdit && <div
                                            className='flex flex-row justify-content-end align-items-end  mb-8'
                                            style={{
                                                height: 110,
                                            }}>

                                            <Button icon="fas fa-trash" className={"p-button-rounded p-button-header mr-2 mb-2"}
                                                onClick={() => {
                                                    onRemoveHeaderImage(profileInfo);

                                                }}

                                            />
                                            <Button icon="fas fa-cloud-arrow-up" className={"p-button-rounded p-button-header mr-2 mb-2"}

                                                onClick={() => {
                                                    setImageFileType(Constants.fileTypes.profile_header);
                                                    setAddImageVisible(true)
                                                }
                                                }
                                            />



                                        </div>
                                    }
                                    <div className='flex flex-row align-items-center responsive-grid '>

                                        {
                                            (isEdit || featuredExhibitFirst?.id) &&
                                            <div style={{ width: itemWidth, height: itemHeight }}>

                                                <CarouselItemTemplate exhibition={featuredExhibitFirst}
                                                    isLast={false} isEdit={isEdit}
                                                    fileUploadRef={featuredExhibitFirst.fileUploadRef}
                                                    id={featuredExhibitFirst.id}
                                                    onUploadFile={() => featuredExhibitHandler(Constants.featuredExhibition.first)}
                                                    onDeleteFile={() => setFeaturedExhibitFirst(defaultFeaturedExhibit)}
                                                />

                                            </div>
                                        }
                                        {
                                            (isEdit || featuredExhibitSecond?.id) &&
                                            <div style={{ width: itemWidth, height: itemHeight }}>

                                                <CarouselItemTemplate exhibition={featuredExhibitSecond}
                                                    isLast={false} isEdit={isEdit}
                                                    fileUploadRef={featuredExhibitSecond.fileUploadRef}
                                                    id={featuredExhibitSecond.id}
                                                    onUploadFile={() => featuredExhibitHandler(Constants.featuredExhibition.second)}
                                                    onDeleteFile={() => setFeaturedExhibitSecond(defaultFeaturedExhibit)}
                                                />

                                            </div>

                                        }
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                    {
                        renderExhibits()
                    }

                    {
                        renderArtWorks()
                    }


                </div>

            </div>
            {
                uploadImageLayer()
            }
            {
                inviteLayer()
            }
            {
                selectFeaturedExhibitLayer()
            }
        </div >
    );
};

